<template>
  <div class="merchant">
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div v-if="column.field === 'action'">
          <Button buttonText="Kirim Ulang Verifikasi" v-if="!entry.verified_at" type="secondary" size="small" @action="doResend(entry.id)" />
          <span v-else class="text-system-success">Terverifikasi</span>
        </div>
        <span class="block break-all" v-else-if="column.field === 'id'">
          {{ entry[column.field] }}
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data() {
    return {
      searchTerm: '',
      isModalVisible: false,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true,
      columns: [
        { label: 'ID', field: 'id' },
        { label: 'Nama Merchant', field: 'name' },
        { label: 'Nama Admin Pengirim', field: 'sender_name' },
        { label: 'No. Handphone', field: 'sender_phone' },
        { label: 'Email', field: 'email' },
        { label: 'Verifikasi', field: 'action' }
      ]
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('merchant', ['selfRegistration']),
    filteredData() {
      let temp = this.selfRegistration
      temp = temp.filter((item) => {
        return item.code !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/self-registration', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getListMerchant()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getListMerchant()
      } else {
        this.$router.push({ path: '/self-registration', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('merchant', ['getSelfRegistration', 'resendVerification']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    doResend(registerId) {
      this.showLoading()
      this.resendVerification({
        registerId: registerId
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 2000, primaryText: 'Request Kirim Ulang Verifikasi Berhasil Diproses', secondaryText: '', callback: () => {} }
        })
      })
    },
    getListMerchant() {
      this.showLoading()
      this.getSelfRegistration({
        params: {
          sort: 'DESC',
          page: this.currentPage,
          per_page: this.pageSize
        }
      })
        .then((res) => {
          this.hideLoading()
          this.totalRecords = res.data.meta.total_item
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/self-registration', query: { page: page } })
    }
  }
}
</script>
